import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '@components/common/Button';
import './reAuthenticationModal.css';
import { buttonNames, REGEX_PATTERNS } from '@constants/appConstants';

interface ReAuthenticationModalProps {
  showModal: boolean;
  handleClose: (confirmed: boolean) => void;
  beneficiaryData: any;
  abdmData?: any;
  isBenfVerification?: boolean;
}

const ReAuthenticationModal: React.FC<ReAuthenticationModalProps> = ({
  showModal,
  handleClose,
  beneficiaryData,
  abdmData,
  isBenfVerification = false,
}) => {
  const formatDate = (dateValue: string) => {
    if (!dateValue) return '';
    
    if (REGEX_PATTERNS.DATE_DD_MM_YYYY.test(dateValue)) {
      return dateValue;
    }
    
    const date = new Date(dateValue);
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString('en-GB').replace(/\//g, '-');
    }
    
    return dateValue;
  };

  const rchData = {
    name: beneficiaryData?.benf_name || '',
    dob: formatDate(beneficiaryData?.dob),
    abhaId: beneficiaryData?.abha_id || '',
  };

  const abdmProfileData = {
    name: abdmData?.name || '',
    dob: formatDate(abdmData?.dob),
    abhaId: abdmData?.abhaId || '',
  };

  return (
    <Modal
      show={showModal}
      onHide={() => handleClose(false)}
      centered
      backdrop="static"
      dialogClassName="re-auth-modal-dialog"
    >
      <Modal.Header closeButton className="re-auth-modal-header">
        <Modal.Title className="re-auth-modal-title">
          {isBenfVerification ? 'Authentication' : 'Re-Authentication'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="re-auth-modal-body">
        <p className="re-auth-modal-description">
          {isBenfVerification
            ? 'Beneficiary name mismatch detected. Please review.'
            : 'Beneficiary details mismatch detected. Please review.'}
        </p>

        <div className="re-auth-comparison-table">
          <div className="re-auth-table-header">
            <div className="re-auth-table-field-col"></div>
            <div className="re-auth-table-rch-col">JANANI Data</div>
            <div className="re-auth-table-abdm-col">ABDM Data</div>
          </div>

          {/* Name Row */}
          <div className="re-auth-table-row">
            <div className="re-auth-table-field-col">Name</div>
            <div className="re-auth-table-rch-col">
              {rchData.name || '-'}
            </div>
            <div className="re-auth-table-abdm-col">
              {abdmProfileData.name || '-'}
              {abdmProfileData.name && rchData.name && (
                <span
                  className={`re-auth-match-icon ${
                    rchData.name.trim() === abdmProfileData.name.trim()
                      ? 're-auth-match'
                      : 're-auth-mismatch'
                  }`}
                >
                  {rchData.name.trim() === abdmProfileData.name.trim()
                    ? '✔'
                    : '⚠'}
                </span>
              )}
            </div>
          </div>

          {!isBenfVerification && (
            <div className="re-auth-table-row">
              <div className="re-auth-table-field-col">DOB</div>
              <div className="re-auth-table-rch-col">
                {rchData.dob || '-'}
              </div>
              <div className="re-auth-table-abdm-col">
                {abdmProfileData.dob || '-'}
                {abdmProfileData.dob && rchData.dob && (
                  <span
                    className={`re-auth-match-icon ${
                      rchData.dob === abdmProfileData.dob
                        ? 're-auth-match'
                        : 're-auth-mismatch'
                    }`}
                  >
                    {rchData.dob === abdmProfileData.dob ? '✔' : '⚠'}
                  </span>
                )}
              </div>
            </div>
          )}

          {!isBenfVerification && (
            <div className="re-auth-table-row">
              <div className="re-auth-table-field-col">ABHA ID</div>
              <div className="re-auth-table-rch-col">
                {rchData.abhaId || '-'}
              </div>
              <div className="re-auth-table-abdm-col">
                {abdmProfileData.abhaId || '-'}
                {abdmProfileData.abhaId && rchData.abhaId && (
                  <span
                    className={`re-auth-match-icon ${
                      rchData.abhaId === abdmProfileData.abhaId
                        ? 're-auth-match'
                        : 're-auth-mismatch'
                    }`}
                  >
                    {rchData.abhaId === abdmProfileData.abhaId ? '✔' : '⚠'}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="re-auth-modal-footer">
        <Button
          onClick={() => handleClose(true)}
          buttonName={buttonNames.yes}
          colorType="primary"
          id="re-auth-yes-btn"
          dataTestId="re-auth-yes-btn"
        />
        <Button
          onClick={() => handleClose(false)}
          buttonName= {buttonNames.no}
          colorType="secondary"
          id="re-auth-no-btn"
          dataTestId="re-auth-no-btn"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ReAuthenticationModal;
